var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('SideMenu'),_c('Header',{attrs:{"title":"Содержание","theme":"white"}}),_c('div',{staticClass:"main-content"},[_c('MediaFiles')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }